import { FC } from "react";

import { LocationChipsProps } from "./location-chips.types";
import { LocationChipsView } from "./location-chips-view";
import { useLocationChips } from "./use-location-chips";

export const LocationChips: FC<LocationChipsProps> = ({ locations, removeValue, registryCode }) => {
  const logic = useLocationChips({
    locations,
    registryCode,
  });
  return <LocationChipsView {...logic} removeValue={removeValue} />;
};
